import { ComponentPropsWithoutRef } from 'react';

export default function UnsortedIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="8px"
      height="9px"
      viewBox="0 0 8 9"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="um-/-positions"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.300000012"
      >
        <g
          id="um-/-positions-/-2.1"
          transform="translate(-41.000000, -462.000000)"
          fill="#7FABEC"
        >
          <g id="sort-/-disabled" transform="translate(41.000000, 462.000000)">
            <path
              d="M7.14644661,5.85355339 L4.35355339,8.64644661 C4.15829124,8.84170876 3.84170876,8.84170876 3.64644661,8.64644661 L0.853553391,5.85355339 C0.658291245,5.65829124 0.658291245,5.34170876 0.853553391,5.14644661 C0.94732158,5.05267842 1.07449854,5 1.20710678,5 L6.79289322,5 C7.06903559,5 7.29289322,5.22385763 7.29289322,5.5 C7.29289322,5.63260824 7.2402148,5.7597852 7.14644661,5.85355339 Z"
              id="Stroke-1"
            />
            <path
              d="M7.14644661,0.853553391 L4.35355339,3.64644661 C4.15829124,3.84170876 3.84170876,3.84170876 3.64644661,3.64644661 L0.853553391,0.853553391 C0.658291245,0.658291245 0.658291245,0.341708755 0.853553391,0.146446609 C0.94732158,0.0526784202 1.07449854,-1.97684866e-16 1.20710678,0 L6.79289322,0 C7.06903559,-9.38904951e-16 7.29289322,0.223857625 7.29289322,0.5 C7.29289322,0.632608245 7.2402148,0.759785201 7.14644661,0.853553391 Z"
              id="Stroke-1"
              transform="translate(4.000000, 2.000000) rotate(-180.000000) translate(-4.000000, -2.000000) "
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
